import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'

import { Address } from 'models/Auth'
import { getAddressByCEP } from 'services/me'

interface UseGetAddressByCepProps extends Pick<UseQueryOptions<Address>, 'onSuccess' | 'onError' | 'enabled'> {
  cep: string
}

export const useGetAddressByCep = ({ cep, ...props }: UseGetAddressByCepProps): UseQueryResult<Address> => {
  return useQuery({
    queryKey: ['GET_ADDRESS_BY_CEP', cep],
    queryFn: () => getAddressByCEP(cep),
    staleTime: 0,
    ...props
  })
}